// extracted by mini-css-extract-plugin
export default {"cert":"style_cert__VmLRE","horizontalCerts":"style_horizontalCerts__6YkiO","horizontalCert":"style_horizontalCert__v9yKw"};